import React from "react";

import { IconProps } from "../types";

import { BaseSVGIcon } from "./base-svg-icon";

export const Available24Variation: React.FC<IconProps> = (props) => {
  return (
    <BaseSVGIcon width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        fill="currentColor"
        stroke="#287137"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8 11.6667L10.6667 14.3333L16 9"
        stroke="#EAF2EC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVGIcon>
  );
};
